import React from 'react'
import Group from 'components/utils/Group'
import Heading from 'components/Luxkit/Typography/Heading'
import BodyText from 'components/Luxkit/Typography/BodyText'
import TextLink from 'components/Luxkit/TextLink'

interface Props {
  onResetFilter?: () => void;
  showReviewFiltersAndUserDetails?: boolean;
}

function UserReviewEmptyState(props: Props) {
  const { onResetFilter, showReviewFiltersAndUserDetails = true } = props

  return (
    <Group fullWidth direction="vertical" horizontalAlign="center" gap={4}>
      {!showReviewFiltersAndUserDetails && <Heading variant="heading6">Sorry, there are no reviews</Heading>}
      {showReviewFiltersAndUserDetails && <>
        <Heading variant="heading6">Sorry, there are no reviews for your selection</Heading>
        <BodyText variant="medium">
          Please try adjusting your filters below or
          {' '}
          <TextLink size="medium" weight="bold" onClick={onResetFilter}>
            show all reviews
          </TextLink>
        </BodyText>
      </>}
    </Group>
  )
}

export default UserReviewEmptyState
